<template>
  <div class="generate-result-page">
    <!-- 导航栏：统一风格 -->
    <div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
      <div class="back-btn" @click="onBack">
        <img src="@/assets/back.svg" class="back-icon" />
      </div>
      <div class="nav-title">我的形象</div>
    </div>
    <div class="page-body">
      <div class="centerTable">
     
        <div
          class="centerTableItem"
          :class="
            centerTableActive == item.code ? 'centerTableItem_active' : ''
          "
          v-for="(item, index) in centerTableList"
          :key="index"
          @click="changeItem(item)"
        >
          {{ item.name }}
        </div>
           <img
          src="@/assets/aiVideo/refresh.png"
          alt="#"
          class="newTitleDivImg"
          @click="refreshClick"
        />
      </div>
      <div class="history-content-box" ref="contentBox">
        <!-- 有数据时显示列表 -->
        <div v-if="videoList.length > 0 && centerTableActive == 1">
          <div class="record-list">
            <div
              class="record-item"
              v-for="(item, index) in videoList"
              :key="index"
            >
              <div class="record-itemFirst" @click="changeShowVideo(item)">
                <img :src="item.fileImageUrl" class="record-itemFirst-img" />
              </div>

              <img
                src="@/assets/aiVideo/delete.svg"
                alt="#"
                class="record-item-delete"
                v-if="item.avatarType != 1"
                @click.stop="deleteVideo(item.id)"
              />

              <div class="record-item-bottom">
                <div class="record-item-bottomTitle">{{ item.name }}</div>
                <img
                  src="@/assets/aiVideo/edit.svg"
                  alt="编辑"
                  class="record-item-edit"
                  @click.stop="handlePlayEdit(item, 'xx')"
                  v-if="item.avatarType != 1"
                />
              </div>
            </div>
            <div
              v-for="i in placeholderCount"
              :key="'placeholder-' + i"
              class="zwDiv"
            ></div>
          </div>
          <div
            class="load-tip"
            v-if="
              centerTableActive === 1 && !videoHasMore && videoList.length > 0
            "
          >
            没有更多数据了
          </div>
        </div>

        <div v-else-if="textList.length > 0 && centerTableActive == 2">
          <div class="text-list-container">
            <VoiceItem
              v-for="voice in textList"
              :key="voice.id"
              :voice="voice"
              :editType="true"
              :ref="`voiceItem_${voice.id}`"
              @request-play="handleRequestPlay"
              @delete="handleDeleteVoice"
              @play-error="handlePlayError"
              @edit="handlePlayEdit"
            />
          </div>
          <div
            class="load-tip"
            v-if="
              centerTableActive === 2 && !noteHasMore && textList.length > 0
            "
          >
            没有更多数据了
          </div>
        </div>
        <div class="load-tip" v-else-if="isLoading">加载中...</div>

        <!-- 无数据时显示空状态（通过height:100%居中） -->
        <div class="empty-state" v-else>
          <img src="@/assets/nodata.png" class="empty-img" />
          <div class="empty-text">暂无记录</div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="bottomBtn" :class="canClick ? 'noClick' : ''" @click="goPage">
        {{ centerTableActive == "1" ? "定制新的形象" : "定制新的声音" }}
      </div>
    </div>
    <FullScreenVideo :src="videoSrc" @goBack="goBack" v-if="showVideo" />
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <!-- 弹窗内容（阻止冒泡） -->
      <div class="modal-content" @click.stop>
        <div class="modal-title">名称修改</div>
        <div class="modal-body">
          <div class="modal-text">
            <input
              type="text"
              v-model="fileTitle"
              class="custom-input"
              placeholder="请输入名称"
            />
          </div>
        </div>
        <div class="modal-confirm-div">
          <div class="modal-confirm-btn" @click="closeModal">关闭</div>
          <div class="modal-confirm-btn-ff" @click="submitFileTitle">更改</div>
        </div>
      </div>
    </div>
    <div v-if="showDeleteModal" class="modal-overlay" @click="closeDeleteModal">
      <div class="modal-content" @click.stop>
        <div class="modal-title">提示</div>
        <div class="modal-body">
          <div class="modal-text">{{ deleteMesasage }}</div>
        </div>
        <div class="modal-confirm-div">
          <div class="modal-confirm-btn" @click="closeDeleteModal">取消</div>
          <div class="modal-confirm-btn-ff" @click="confirmDelete">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  pageAvatarInfo,
  deleteAvatarById,
  queryVoice,
  deleteVoice,
  editAvatar,
  updateVoice,
  queryVoCount,
} from "@/api";
import VoiceItem from "@/components/voiceItem.vue";
import FullScreenVideo from "@/components/fullScreenVideo.vue";

// 在 script 顶部导入图片
export default {
  name: "myFigure",
  components: {
    VoiceItem,
    FullScreenVideo,
  },
  data() {
    return {
      showDeleteModal: false,
      showModal: false,
      showVideo: false,
      // 分页配置
      pageSize: 20, // 每页条数
      // AI海报分页
      videoPageNumber: 1,
      videoHasMore: true,
      // AI笔记分页
      notePageNumber: 1,
      noteHasMore: true,
      // AI视频分页（暂不处理）
      // 列表数据
      videoList: [],
      textList: [],
      // 加载状态（防止重复请求）
      isLoading: false,
      title: "",
      content: "",
      vipType: "",
      showVipTipModal: false,
      centerTableActive: 1,
      centerTableList: [
        { code: 1, name: "出镜形象" },
        { code: 2, name: "声音" },
      ],
      videoSrc: "",
      fileTitle: "",
      editType: "",
      submitParams: {},
      videoCount: "",
      voiceCount: "",
      deleteId: "",
      deleteMesasage: "",
      deleteType: "",
	  currentPlatform: '',
    };
  },
  computed: {
 
    placeholderCount() {
      const remainder = this.videoList.length;
      return (3 - (remainder % 3)) % 3; // 当余数为0时返回0，避免多添加占位元素
    },
    canClick() {
      if (
        (this.centerTableActive == "1" && this.videoCount > 2) ||
        (this.centerTableActive == "2" && this.voiceCount > 2)
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
	  document.title = "我的形象";
	  this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
    this.haveQueryVoCount();
    this.gethistoryImg();
    this.listenScroll();
    sessionStorage.setItem("formPage", "");
  },
  methods: {
       refreshClick() {
      this.haveQueryVoCount();
      this.changeItem({ code: this.centerTableActive });
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
    },
    async haveQueryVoCount() {
      let data = await queryVoCount();
      this.videoCount = data.videoCount;
      this.voiceCount = data.voiceCount;
    },
    closeModal() {
      this.showModal = false;
    },
    changeShowVideo(item) {
      this.videoSrc = item.sampleUrl;
      this.showVideo = true;
    },
    goBack() {
      this.showVideo = false;
    },

    // 返回按钮逻辑
    onBack() {
      this.$router.push({
        path: "aiVideo",
      });
    },
    goPage() {
      if (this.canClick) {
        return;
      }
      let path = this.centerTableActive == "1" ? "customAvatar" : "customVoice";
      // if (path == "customAvatar") {
      // return (
      //   this.$toast &&
      //   this.$toast("定制形象最多为3个，请删除历史形象后再重新定制")
      // );
      // }
      // if (path == "customVoice") {
      // return (
      //   this.$toast &&
      //   this.$toast("定制声音最多为3个，请删除历史声音后再重新定制")
      // );
      // }
      sessionStorage.setItem("formPage", "myFigure");
      this.$router.push({
        path: path,
        query: { formPath: "myFigure" },
      });
    },
    changeItem(item) {
      this.pauseAllVoices(); // 页面销毁前清理

      this.centerTableActive = item.code;
      // 重置加载状态
      this.isLoading = false;
      // 根据选项重置对应数据和分页
      switch (item.code) {
        case 1: // AI海报
          this.videoList = [];
          this.videoPageNumber = 1;
          this.videoHasMore = true;
          this.gethistoryImg(); // 重新拉取第一页
          break;
        case 2: // AI笔记
          this.textList = [];
          this.notePageNumber = 1;
          this.noteHasMore = true;
          this.gethistoryNote(); // 重新拉取第一页
          break;
      }
    },
    loadMore() {
      // 正在加载/无更多数据，直接返回
      if (this.isLoading) return;
      switch (this.centerTableActive) {
        case 1:
          if (this.videoHasMore) {
            this.videoPageNumber++;
            this.gethistoryImg();
          }
          break;
        case 2:
          if (this.noteHasMore) {
            this.notePageNumber++;
            this.gethistoryNote();
          }
          break;
      }
    },

    // 5. 监听滚动到底部
    listenScroll() {
      const contentBox = this.$refs.contentBox;
      if (!contentBox) return;
      contentBox.addEventListener("scroll", () => {
        // 滚动到底部的判断：滚动高度 + 可视高度 >= 总高度 - 100（提前加载）
        const { scrollTop, clientHeight, scrollHeight } = contentBox;
        if (scrollTop + clientHeight >= scrollHeight - 100) {
          this.loadMore();
        }
      });
    },
    // 计算需要多少个占位 div

    async gethistoryImg() {
      if (!this.videoHasMore || this.isLoading) return;
      this.isLoading = true;
      try {
        const data = await pageAvatarInfo({
          pageNumber: this.videoPageNumber,
          pageSize: this.pageSize,
        });
        // 关键：获取总条数 + 兜底
        const totalRow = data?.totalRow || 0;
        if (data && Array.isArray(data.records)) {
          // 拼接数据
          if (this.videoPageNumber === 1) {
            this.videoList = data.records;
          } else {
            this.videoList = [...this.videoList, ...data.records];
          }
          // 新判断逻辑：已加载数量 < 总条数 → 还有更多
          this.videoHasMore = this.videoList.length < totalRow;
        } else {
          this.videoHasMore = false;
        }
      } catch (error) {
        this.videoHasMore = false;
      } finally {
        this.isLoading = false;
      }
    },
    async gethistoryNote() {
      if (!this.noteHasMore || this.isLoading) return;
      this.isLoading = true;
      try {
        const data = await queryVoice({
          pageNum: this.notePageNumber,
          pageSize: this.pageSize,
        });
        // 关键：获取总条数 + 兜底
        const totalRow = data?.totalRow || 0;
        if (data && Array.isArray(data.records)) {
          // 拼接数据
          if (this.notePageNumber === 1) {
            this.textList = data.records.map((e) => {
              return {
                ...e,
                name: e.name,
                url: e.copySoundUrl,
              };
            });
          } else {
            this.textList = [...this.textList, ...data.records];
          }
          // 新判断逻辑：已加载数量 < 总条数 → 还有更多
          this.noteHasMore = this.textList.length < totalRow;
        } else {
          this.noteHasMore = false;
        }
      } catch (error) {
        this.noteHasMore = false;
      } finally {
        this.isLoading = false;
      }
    },
    // ✅ 主动暂停所有音频
    pauseAllVoices() {
      for (const voice of this.textList) {
        const refName = `voiceItem_${voice.id}`;
        const instances = this.$refs[refName];
        if (instances && Array.isArray(instances) && instances[0]) {
          instances[0].pause(); // v-for 中的 ref 是数组
        }
      }
      this.currentPlayingVoice = null;
    },
    // 协调播放：确保只有一个在播
    handleRequestPlay(voiceComponent) {
      if (
        this.currentPlayingVoice &&
        this.currentPlayingVoice !== voiceComponent
      ) {
        this.currentPlayingVoice.pause();
      }
      this.currentPlayingVoice = voiceComponent;
    },

    handlePlayEdit(voice, type) {
      console.log(type);
      this.submitParams = {
        id: voice.id,
      };
      if (type && type == "xx") {
        this.editType = "xx";
      } else {
        this.editType = "sy";
      }
      this.showModal = true;
      this.fileTitle = voice.name;
      console.log(voice, "voice");
      // this.textList = this.textList.filter(v => v.id !== voice.id);
      // if (this.currentPlayingVoice?.voice?.id === voice.id) {
      //   this.currentPlayingVoice = null;
      // }
    },
    async submitFileTitle() {
      if (!this.fileTitle) {
        this.$toast && this.$toast("名称不可为空");
      }
      if (this.editType == "xx") {
        await editAvatar({ ...this.submitParams, name: this.fileTitle });
        this.changeItem({ code: 1 });
      } else {
        await updateVoice({ ...this.submitParams, name: this.fileTitle });
        this.changeItem({ code: 2 });
      }
      this.closeModal();
    },
    handlePlayError(error) {
      this.$toast && this.$toast("音频播放失败，请检查网络或浏览器权限");
    },
    async deleteVideo(id) {
      this.deleteMesasage = "确定要删除此形象吗？";
      this.showDeleteModal = true;
      this.deleteId = id;
      this.deleteType = "video";
    },
    async handleDeleteVoice(voice) {
      this.deleteMesasage = "确定要删除此声音吗？";
      this.showDeleteModal = true;
      this.deleteId = voice.voiceId;
      this.deleteType = "voice";
    },
    async confirmDelete() {
      if (this.deleteType == "video") {
        let data = await deleteAvatarById({ id: this.deleteId });
        if (data) {
          this.changeItem({ code: 1 });
          this.$toast && this.$toast("删除出镜形象成功");
          this.showDeleteModal = false;
          this.haveQueryVoCount();
        }
      } else {
        let data = await deleteVoice(this.deleteId);
        if (data == "success") {
          this.changeItem({ code: 2 });
          this.$toast && this.$toast("删除声音成功");
          this.showDeleteModal = false;
          this.haveQueryVoCount();
        }
      }
    },
  },
  beforeDestroy() {
    this.pauseAllVoices(); // 页面销毁前清理
  },
};
</script>

<style scoped>
/* 页面基础布局 */
.generate-result-page {
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
}

/* 导航栏（与原页面完全统一） */
.custom-nav-bar {
  width: 100%;
  height: 11.7333vw;
  background-image: linear-gradient(90deg, #e7f2fa 0%, #dbe2f1 100%);
  box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
  position: relative;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex-shrink: 0;
}

.back-btn {
  width: 6.4vw;
  height: 6.4vw;
  position: absolute;
  left: 2.6667vw;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.nav-title {
  font-family: SourceHanSansSC-Medium;
  font-size: 4.8vw;
  color: #000000;
  letter-spacing: 0.1333vw;
  text-align: center;
  line-height: 11.7333vw;
  font-weight: 500;
}
.page-body {
  overflow-y: auto;
  padding: 5.333vw 4.2666vw 0 4.2666vw;
}
.bodayTitle {
  height: 6.2666vw;
  color: #1f2226;
  font-weight: 700;
  font-size: 4.2666vw;
  text-align: left;
  line-height: 6.2666vw;
  opacity: 0.9;
  padding-bottom: 2.133vw;
  border-bottom: 0.2666vw solid #e4e8ec;
}
.centerTable {
  display: flex;
  align-items: center;
  /* margin: 0 4.2666vw; */
  border-bottom: 0.2666vw solid #e4e8ec;
  padding-bottom: 2.1333vw;
  position: relative;
}
.newTitleDivImg{
  width: 5vw;
  height: 5vw;
  position: absolute;
  right: 3vw;
}
.centerTableItem {
  color: #666666;
  font-weight: 500;
  font-size: 3.7333vw;
  height: 5.4666vw;
  line-height: 5.4666vw;
}
.centerTableItem_active {
  /* opacity: 0.9; */
  color: #1f2226;
  font-weight: 700;
  font-size: 4.2666vw;
  height: 6.2666vw;
  line-height: 6.2666vw;
}
.centerTable > .centerTableItem:first-child {
  margin-right: 4.2666vw;
}
.history-content-box {
  margin-top: 3.2vw;

  width: 100%;
  height: calc(100vh - 54.5332vw);
  height: calc(100dvh - 54.5332vw);
  /* flex: 1; */
  box-sizing: border-box;
  overflow-y: auto;
  /* 仅此处纵向滚动 */
  overflow-x: hidden;
  /* 禁止横向滚动 */
  padding-bottom: 2vw;
  /* 底部留白优化体验 */
  /* 移除居中样式（有数据时不需要居中，空状态单独处理） */
  display: block;
  -webkit-overflow-scrolling: touch;
  /* 保留移动端弹性滚动 */
  scrollbar-width: none;
  /* Firefox 隐藏滚动条 */
  -ms-overflow-style: none;
  /* IE/Edge 隐藏滚动条 */
}

.history-content-box::-webkit-scrollbar {
  display: none;
  /* 隐藏滚动条 */
  width: 0;
  height: 0;
}

.history-content-box::-webkit-scrollbar-track {
  background: transparent;
}

.history-content-box::-webkit-scrollbar-thumb {
  background: transparent;
}

/* 无数据状态容器 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  /* 撑满content-box高度实现居中 */
}

/* 无数据图片样式 */
.empty-img {
  width: 26.6667vw;
  /* 200px = 200/7.5 = 26.6667vw */
  height: 21.3333vw;
  /* 160px = 160/7.5 = 21.3333vw */
  object-fit: contain;
  /* 保持图片比例 */
}

/* 无数据文字样式 */
.empty-text {
  margin-top: 4.2667vw;
  /* 32px = 32/7.5 = 4.2667vw */
  font-family: SourceHanSansSC-Regular;
  font-size: 3.2vw;
  /* 24px = 24/7.5 = 3.2vw */
  color: #c2c2c2;
  text-align: center;
  font-weight: 400;
}

.record-list {
  /* width: calc(100vw - 8.5334vw); */
  display: flex;
  flex-wrap: wrap;
  /* 自动换行 */
  justify-content: space-around;
  /* 横向等分间距 */
  box-sizing: border-box;
}
.record-item {
  position: relative;
}
.record-itemFirst {
  position: relative;
  width: 25.6vw;
  height: 48vw;
  border-radius: 2.1333vw;
  background-color: #d8d8d8;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
}
.record-itemFirst-img {
  width: 25.6vw;
  height: 48vw;
  border-radius: 2.1333vw;
  object-fit: cover;
}
.record-item-delete {
  position: absolute;
  width: 4.2666vw;
  height: 4.2666vw;
  top: 1.6vw;
  right: 1.6vw;
}
.record-item-bf {
  position: absolute;
  width: 8vw;
  height: 8vw;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.record-item-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.record-item-bottomTitle {
  max-width: 19.8666vw;
  line-height: 4.8vw;
  font-family: SourceHanSansSC-Regular;
  font-size: 3.2vw;
  color: #1f2226;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 1.6vw;
  margin-bottom: 1.6vw;
}
.record-item-edit {
  width: 3.2vw;
  height: 3.2vw;
}
.zwDiv {
  width: 25.6vw;
}
/* 记录项内图片 */
.record-img {
  width: 100%;
  /* 宽度占满容器 */
  height: 100%;
  /* 高度自适应（这里用100%撑满容器，也可写auto） */
  object-fit: contain;
  /* 保持图片比例，不拉伸 */
  display: block;
  /* 去除图片默认间隙 */
}

.yyyp {
  margin-bottom: 1.6vw;
}

/* 单个文字字符串容器 */
.text-item {
  width: 100%;
  /* 宽度占满 */
  height: auto;
  background-color: rgba(240, 244, 248, 0.6);
  box-shadow: 0px 0.2667vw 0px 0px rgba(234, 236, 241, 1);
  /* -2px = -0.2667vw */
  box-sizing: border-box;
  padding: 2.133vw 4.1333vw 2.133vw 3.2vw;
  margin-bottom: 2.133vw;
}

/* 文字内容样式 */
.text-content {
  opacity: 0.8;
  font-family: SourceHanSansSC-regular;
  color: #333333;
  font-weight: 400;
  font-size: 2.9333vw;
  /* 22px = 22/7.5 */
  font-style: normal;
  text-decoration: none;
  text-align: left;
  line-height: 1.5;
  /* 增加行高，提升可读性 */
  word-wrap: break-word;
  /* 自动换行 */
  word-break: break-all;
  /* 兼容长字符串换行 */
}

.load-tip {
  text-align: center;
  padding: 2.6667vw 0;
  font-size: 2.6667vw;
  color: #999;
}
.record-itemError {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.text-itemNewOne {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.deleteImg {
  width: 4.2666vw;
  height: 4.2666vw;
}
.bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8vw;
}
.bottomBtn {
  width: 53.333vw;
  height: 8vw;
  border-radius: 2.1333vw;
  background: linear-gradient(
    148.76deg,
    rgba(47, 255, 181, 1) 0%,
    rgba(30, 137, 255, 1) 100%
  );
  color: #ffffff;
  font-weight: 500;
  font-size: 3.2vw;
  text-align: center;
  line-height: 8vw;
}
.noClick {
  background: #ebebed !important;
  color: #666666;
}
/* 弹窗遮罩 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

/* 弹窗内容 */
.modal-content {
  width: 80vw;
  /* height: 58.666vw; */
  border-radius: 3.2vw;
  background-color: #ffffff;
}

.modal-title {
  line-height: 6.2666vw;
  color: #666666;
  font-weight: 500;
  font-size: 4.2666vw;
  text-align: center;
  padding: 5.333vw 0 4.2666vw 0;
}
.modal-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.modal-text {
  width: 67.2vw;
  color: #666666;
  font-weight: 400;
  font-size: 3.2vw;
  line-height: 4.8vw;
  margin-top: 1.0666vw;
  text-align: center;
}

.modal-confirm-div {
  display: flex;
  justify-content: center;
  margin-top: 6.5333vw;
  margin-bottom: 5.333vw;
}
.modal-confirm-btn {
  width: 29.333vw;
  height: 10.666vw;
  border-radius: 2.1333vw;
  background-color: #ebebed;
  line-height: 10.666vw;
  opacity: 0.8;
  color: #666666;
  font-weight: 500;
  font-size: 3.2vw;
  text-align: center;
  margin-right: 5.333vw;
}
.modal-confirm-btn-ff {
  width: 29.333vw;
  height: 10.666vw;
  border-radius: 2.1333vw;
  background: linear-gradient(
    148.76deg,
    rgba(47, 255, 181, 1) 0%,
    rgba(30, 137, 255, 1) 100%
  );
  line-height: 10.666vw;
  color: #ffffff;
  font-weight: 500;
  font-size: 3.2vw;
  text-align: center;
}
.custom-input {
  width: 80%;
  height: 10.333vw;
  border: none;
  background-color: #f1f5fd;
  border-radius: 2vw;
  text-indent: 1em;
}
</style>
